import CustomUserCell from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/CustomUserCell';
import { jsx as _jsx } from "react/jsx-runtime";
export const userCell = {
  width: 135,
  renderCell: props => /*#__PURE__*/_jsx(CustomUserCell, Object.assign({}, props))
};